// extracted by mini-css-extract-plugin
export default {"Coconut":"#F4F7FA","container":"Gfd29c2 Gee1693","accountWrap":"Gb0ed50","accountContainer":"G970a3a Gba9ea0 G583824"};